import { type AuthStep, StepNavigationProvider, stepToUrl } from '@jusbrasil-web/shared-auth-flows'
import { useRouter } from 'next/router'
import { type PropsWithChildren, useCallback, useRef } from 'react'

import { AuthFooter } from '../auth-footer'
import { AuthTopbar } from '../auth-topbar'
import styles from './auth-layout.module.scss'

export interface AuthLayoutProps extends PropsWithChildren {
  footerShowAgreementText?: boolean
}

export function AuthLayout({ children, footerShowAgreementText }: AuthLayoutProps) {
  const router = useRouter()
  const routerRef = useRef(router)
  routerRef.current = router

  const handleStepChange = useCallback((step: AuthStep) => {
    const { pathname, query } = stepToUrl(step)
    const { push, query: currentQuery } = routerRef.current
    push({ pathname, query: { ...currentQuery, ...query } })
  }, [])

  return (
    <StepNavigationProvider onStepChange={handleStepChange}>
      <div className={styles.authLayout}>
        <AuthTopbar className={styles.topbar} />
        <div className={styles.content}>{children}</div>
        <AuthFooter className={styles.footer} showAgreementText={footerShowAgreementText} />
      </div>
    </StepNavigationProvider>
  )
}
